export default "__VITE_ASSET__CNxV9sdu__"